// extracted by mini-css-extract-plugin
export default {"wrapper":"YearSeparator_wrapper__QKS5W","line":"YearSeparator_line__+qG0n","year":"YearSeparator_year__O6MYG"};